import { Component, ChangeDetectorRef, OnInit } from '@angular/core'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import {
  AdminPointPlan,
  PointPlansGetRequest,
} from 'src/lib/entity/manage-point'
import { DEVICE_TYPE_LIST } from 'src/lib/constants'
import { ActivatedRoute, Router } from '@angular/router'
import { CommonService } from 'src/lib/services/common-service'

@Component({
  selector: 'maglive-admin-point-plan-index',
  templateUrl: './point-plan-index.component.html',
  styleUrls: [
    './point-plan-index.component.scss',
    '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss',
  ],
})
export class AdminPointPlanIndexComponent implements OnInit {
  // OSタイプの定数
  deviceTypelist = DEVICE_TYPE_LIST
  // 検索パラメータ
  search = {
    deviceType: 'WEB',
    isSalesEndOnly: false,
  }

  pointPlans: AdminPointPlan[] = []
  isScrollBottom = false

  selectedEditItem: AdminPointPlan

  /**
   * 無限スクロール対象要素の親クラス名
   * https://www.npmjs.com/package/ngx-infinite-scroll fromRoot
   */
  infiniteScrollParentSelector = '.admin-point-plan-scroll-wrap'

  // 無限スクロールでデータを取りきったかどうかのフラグ
  private allRead: Boolean = false
  // データ取得中かどうかのフラグ
  isLoading: Boolean = false

  // 無限スクロールの起点となるドキュメントID
  private lastDocumentId: string | null = null

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.search.deviceType =
      this.route.snapshot.queryParamMap.get('deviceType') || 'WEB'
    this.search.isSalesEndOnly =
      this.route.snapshot.queryParamMap.get('isSalesEndOnly') === 'true'
    const request: PointPlansGetRequest = {
      ...this.search,
      lastDocumentId: null,
    }
    this.isLoading = true
    this.getPointPlans(request)
  }

  /**
   * 検索条件に基づいたポイント履歴一覧を取得する
   */
  execSearch(): void {
    this.lastDocumentId = null
    const request: PointPlansGetRequest = {
      ...this.search,
      lastDocumentId: null,
    }
    this.allRead = false
    this.isLoading = true
    this.getPointPlans(request)
    // 強制的に再描画させる
    this.changeDetectorRef.detectChanges()
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...this.search,
      },
    })
  }

  /**
   * スクロールイベントをトリガーする
   */
  onScroll() {
    if (this.allRead || this.isLoading) return
    const request: PointPlansGetRequest = {
      ...this.search,
      lastDocumentId: this.lastDocumentId,
    }
    this.isLoading = true
    this.getPointPlansByScroll(request)
    // 強制的に再描画させる
    this.changeDetectorRef.detectChanges()
  }

  /**
   * ポイントプランを取得する
   */
  getPointPlans(request?: PointPlansGetRequest): void {
    const defaltRequest: PointPlansGetRequest = {
      deviceType: 'WEB',
      isSalesEndOnly: false,
      lastDocumentId: null,
    }
    if (request == null) request = defaltRequest

    MagliveApiClient.getPointPlansForManage(request).subscribe((response) => {
      if (response !== 'NOT_FOUND') {
        this.pointPlans = response.items
        this.lastDocumentId = response.lastDocumentId
      } else {
        this.pointPlans = []
      }
      this.isLoading = false
    })
  }

  /**
   * スクロール時にポイントプランを取得する
   */
  private getPointPlansByScroll(request: PointPlansGetRequest): void {
    MagliveApiClient.getPointPlansForManage(request).subscribe((response) => {
      if (response !== 'NOT_FOUND' && response.items.length > 0) {
        if (this.pointPlans.length !== 0) {
          this.pointPlans = this.pointPlans.concat(response.items)
        } else {
          this.pointPlans = response.items
        }
        this.lastDocumentId = response.lastDocumentId
      } else {
        this.allRead = true
      }
      this.isLoading = false
    })
  }

  /**
   * ポイントプラン編集画面を表示する
   */
  showPointPlanEditView(item: AdminPointPlan): void {
    this.commonService.setPointPlan(item)
    console.log(`item: ${JSON.stringify(item)}`)
    this.router.navigate([item.pointPlanId + '/edit'], {
      relativeTo: this.route,
    })
  }

  trimText(targetStr: string, wordCount: number): string {
    const clamp = '...'
    for (let i = 0; i < targetStr.length; i++) {
      if (targetStr.length > wordCount) {
        targetStr = targetStr.substr(0, wordCount - 1)
        targetStr = targetStr + clamp
      }
    }

    return targetStr
  }
}
